import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=162742b9&scoped=true"
import script from "./MaterialDetail.vue?vue&type=script&lang=ts"
export * from "./MaterialDetail.vue?vue&type=script&lang=ts"
import style0 from "./MaterialDetail.vue?vue&type=style&index=0&id=162742b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162742b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162742b9')) {
      api.createRecord('162742b9', component.options)
    } else {
      api.reload('162742b9', component.options)
    }
    module.hot.accept("./MaterialDetail.vue?vue&type=template&id=162742b9&scoped=true", function () {
      api.rerender('162742b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/materials/MaterialDetail.vue"
export default component.exports